import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

const exactPadding = (y: number, x: number) => `${y}px ${x}px`;

export const SummaryCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  color: '#333',
  borderRadius: theme.shape.borderRadius,
  
  // Padding inside the white card
  padding: exactPadding(10, 16), // Reduced padding
  
  marginTop: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  
  // --- CHANGE HERE: Center the items ---
  justifyContent: 'center', 
  
  // --- CHANGE HERE: Add space between Date and Position ---
  gap: theme.spacing(2), // reduced gap
  
  width: '100%',
  maxWidth: 280, // Reduced maxWidth to fit in smaller panel
  boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
}));

// ... (GreenPanel, InfoItem, WorkerCard remain the same)
export const GreenPanel = styled(Box)(({ theme }) => ({
  backgroundColor: '#5E8E7E',
  color: '#fff',
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: '100%',
  position: 'relative',
}));

export const InfoItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  '& svg': { fontSize: '18px', color: '#555' },
  '& span': { fontSize: '14px', fontWeight: 500 },
});

export const WorkerCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1.5),
  boxShadow: 'none',
  border: '1px solid #eee',
  borderRadius: theme.shape.borderRadius,
}));